import {
  configureStore
} from "@reduxjs/toolkit";
import { antdLayoutInfoSlice } from "./reducer/antd-layout-info.reducer";
import { alertMessageSlice } from "./reducer/alert-message.reducer";
import { sessionSlice } from "./reducer/session.reducer";

export const store = configureStore({
  reducer: {
    antdLayoutInfo: antdLayoutInfoSlice.reducer,
    alertMessage: alertMessageSlice.reducer,
    session: sessionSlice.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;